<template>
  <div
    class="tw-w-56 tw-h-12 tw-rounded tw-flex tw-items-center tw-justify-between tw-text-sm tw-px-4 tw-shadow"
    :class="color.blackText ? 'tw-text-black tw-text-opacity-70' : 'tw-text-white'"
    :style="`background: ${color.hex}`"
  >
    <span class="tw-font-bold">
      {{ color.title }}
    </span>
    <span>
      {{ color.hex }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    color: {
      type: Object,
      required: true,
    },
  },
};
</script>
